export const DEFAULT_THREAD_DISPATCH_KEY = "__default__";

export const threadDispatchKey = (threadUuid) =>
  threadUuid || DEFAULT_THREAD_DISPATCH_KEY;

export const getActiveThreadDispatch = (registry, threadUuid) =>
  (registry || {})[threadDispatchKey(threadUuid)] || null;

export const hasActiveThreadDispatch = (registry, threadUuid) =>
  Boolean(getActiveThreadDispatch(registry, threadUuid));

export const setActiveThreadDispatch = (registry, threadUuid, dispatch) => {
  if (!dispatch) return registry || {};
  return {
    ...(registry || {}),
    [threadDispatchKey(threadUuid)]: dispatch,
  };
};

export const clearActiveThreadDispatch = (
  registry,
  threadUuid,
  expectedRequestToken = null,
) => {
  const key = threadDispatchKey(threadUuid);
  const current = (registry || {})[key] || null;
  if (!current) {
    return {
      registry: registry || {},
      cleared: false,
      dispatch: null,
    };
  }

  if (
    expectedRequestToken != null &&
    current.requestToken !== expectedRequestToken
  ) {
    return {
      registry: registry || {},
      cleared: false,
      dispatch: current,
    };
  }

  const next = { ...(registry || {}) };
  delete next[key];
  return {
    registry: next,
    cleared: true,
    dispatch: current,
  };
};

export const moveThreadDispatch = (registry, fromThreadUuid, toThreadUuid) => {
  if (!fromThreadUuid || !toThreadUuid || fromThreadUuid === toThreadUuid) {
    return registry || {};
  }

  const fromKey = threadDispatchKey(fromThreadUuid);
  const toKey = threadDispatchKey(toThreadUuid);
  const current = (registry || {})[fromKey];
  if (!current) return registry || {};

  const next = { ...(registry || {}) };
  next[toKey] = current;
  delete next[fromKey];
  return next;
};
